function CustomPageTransition() {
	this.entered = false;
}

CustomPageTransition.prototype.leave = function (doneCallback) {
	this.entered = false;
	gsap.to(".page-transition", {
		opacity: 1,
		duration: 0.5,
		ease: 'power1.out',
		// Ne pas supprimer, sert pour naviguer à la page suivante après la transition
		onStart: () => $('.page-transition').css('pointer-events', 'initial'),
		onComplete: function () {
			doneCallback();
		}
	});
};

CustomPageTransition.prototype.enter = function (doneCallback) {
	if (this.entered) {
		return;
	}

	gsap.to(".page-transition", {
		opacity: 0,
		duration: 0.5,
		ease: 'power1.out',
		// Ne pas supprimer, sert pour lancer les animations après la transition
		onComplete: function () {
			$('.page-transition').css('pointer-events', 'none');
			doneCallback();
		}
	});
	this.entered = true;
};
